export default "__VITE_ASSET__C5eMJN5$__"